var SparkMD5 = require('spark-md5');

module.exports = {
    generateChecksumErrorMessage: function (hash, checksum, fileName) {
        return 'The checksum for ' + fileName + ' does not match. The computed value was ' + hash + ' and the entered value was ' + checksum;
    },
    computeHash: function (file) {
        if (!file) return Promise.resolve(null);
        var fileReader = new FileReader();
        return new Promise(function (resolve, reject) {
            fileReader.readAsBinaryString(file);
            fileReader.onload = function () {
                var hash = SparkMD5.hashBinary(fileReader.result);
                resolve(hash);
            };
            fileReader.onerror = function (error) {
                reject(error);
            };
        });
    }
};
